const ROOT_MARGIN = '600px 0px';
const CONTROLLER_FLAG = 'masonryLazyController';

let observer = null;
const observed = new Set();

function masonryImage(node) {
  return node instanceof HTMLImageElement
    && node.classList.contains('masonry__bg')
    && Boolean(node.closest('.section--masonry'))
    && !node.closest('.pswp');
}

function forget(image) {
  if (!observer || !observed.has(image)) return;
  observer.unobserve(image);
  observed.delete(image);
  if (observed.size === 0) {
    observer.disconnect();
    observer = null;
  }
}

function reveal(image) {
  if (!masonryImage(image) || image.dataset.masonrySettled === 'true') return;
  image.dataset.masonrySettled = 'true';
  forget(image);

  const picture = image.closest('picture');
  picture?.querySelectorAll('source[data-masonry-srcset]').forEach((source) => {
    if (!source.getAttribute('srcset') && source.dataset.masonrySrcset) {
      source.setAttribute('srcset', source.dataset.masonrySrcset);
    }
  });

  if (!image.getAttribute('src') && image.dataset.masonrySrc) {
    image.loading = 'eager';
    image.src = image.dataset.masonrySrc;
  } else if (image.loading === 'lazy') {
    image.loading = 'eager';
  }

  image.classList.add('masonry-bg--settled');
}

function ensureObserver() {
  if (observer || !('IntersectionObserver' in window)) return observer;
  observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      reveal(entry.target);
    });
  }, { rootMargin: ROOT_MARGIN });
  return observer;
}

function init(root = document) {
  if (!root?.querySelectorAll) return;
  const images = Array.from(root.querySelectorAll('.section--masonry img.masonry__bg')).filter(masonryImage);
  const pending = [];

  images.forEach((image) => {
    if (image.dataset.masonrySettled === 'true' || observed.has(image)) return;
    if (image.dataset.masonrySrc && !image.getAttribute('src')) {
      pending.push(image);
      return;
    }
    if (image.loading === 'lazy') reveal(image);
  });

  if (!pending.length) return;
  const nextObserver = ensureObserver();
  if (!nextObserver) {
    pending.forEach(reveal);
    return;
  }

  pending.forEach((image) => {
    observed.add(image);
    nextObserver.observe(image);
  });
}

function start() {
  if (document.documentElement.dataset[CONTROLLER_FLAG] === 'true') return;
  document.documentElement.dataset[CONTROLLER_FLAG] = 'true';
  init(document);
  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target;
    if (!section?.querySelector?.('.section--masonry')) return;
    init(section);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', start, { once: true });
} else {
  start();
}
